import React from 'react';
import { Row, Card, Alert, Form, Button } from 'react-bootstrap';
import Loader from 'react-loader';
import _ from 'lodash';
import fiterAPI from '../fiterAPI';

class RecoverPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      email: '',
      emailSent: false,
      error: false,
      loaded: true
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeField = this.onChangeField.bind(this);
  }

  async onSubmit() {
    const { email } = this.state;
    try {
      this.setState({ emailSent: true, loaded: false });
      await fiterAPI.sendRecoverPasswordEmail(email);
      this.setState({ emailSent: true });
    } catch (err) {
      this.setState({ error: true });
    } finally {
      this.setState({ loaded: true });
    }
  }

  onChangeField(event, field) {
    const value = _.get(event, 'target.value');
    this.setState({ [field]: value });
  }

  render() {
    const { emailSent, email, loaded, error } = this.state;
    return (
      <Row className="justify-content-center mt-5">
        <Card style={{ width: '36rem' }} className="shadow">
          <Card.Body>
            <Card.Title>Recuperar Senha</Card.Title>
            <Loader loaded={loaded}>
              {!emailSent ? (
                <Form>
                  <Card.Text>
                    Informe o email que foi usado para o cadastro. Você receberá
                    em seu email as intruções para recuperação de senha.
                  </Card.Text>
                  <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      onChange={event => this.onChangeField(event, 'email')}
                    />
                  </Form.Group>

                  <Button variant="primary" onClick={this.onSubmit}>
                    Enviar
                  </Button>
                </Form>
              ) : (
                <>
                  {error ? (
                    <Alert variant="danger">
                      Ocorreu um erro, tente novamente mais tarde
                    </Alert>
                  ) : (
                    <Card.Text>
                      Um email foi enviado para {email}. Verifique sua caixa de
                      email.
                    </Card.Text>
                  )}
                </>
              )}
            </Loader>
          </Card.Body>
        </Card>
      </Row>
    );
  }
}

export default RecoverPassword;
